import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {BasicInput, BaasicButton, BaasicFieldDropdown} from 'core/components';

function ImportItemGroupEditTemplate({importItemGroupEditViewStore}) {
    const { 
        form,
        referenceStore
    } = importItemGroupEditViewStore;

    return (
        <section>
            <form onSubmit={form.onSubmit}>
                <div className="modal__header">
                    <h3 className='modal__header__title'>Edit Group</h3>
                    {/* <div className="form__group">
                        <BasicFieldCheckbox field={form.$('billableToMedicare')} />
                    </div> */}
                </div>

                <div className="modal__body">
                    <div className="row">
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode1')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode2')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode3')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode4')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode5')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode6')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode7')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-3">
                            <BasicInput field={form.$('diagnosisCode8')} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form__group col col-sml-12 col-med-6">
                            <BasicInput field={form.$('woundLocation')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            <BasicInput field={form.$('secondaryVerified')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            <BasicInput field={form.$('salesOrderNote')} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form__group col col-sml-12 col-med-6">
                            <BasicInput field={form.$('reference')} />
                        </div>
                        <div className="form__group col col-sml-12 col-med-6">
                            <BaasicFieldDropdown field={form.$('referenceList')} disabled={false} store={referenceStore} />
                        </div>
                    </div>
                </div>

                <div className="modal__footer is-right">
                    <BaasicButton
                        className='btn btn--med btn--primary'
                        type='submit'
                        label='Submit'
                    />
                </div>
            </form>
        </section>
    );
}

ImportItemGroupEditTemplate.propTypes = {
    importItemGroupEditViewStore: PropTypes.object,
    t: PropTypes.func.isRequired
};

export default defaultTemplate(ImportItemGroupEditTemplate);